import {
    HttpRequest,
    HttpHandler,
    HttpEvent,
    HttpInterceptor,
    HttpErrorResponse,
    HttpResponse
} from '@angular/common/http';
import { Observable } from 'rxjs';
import { Injectable } from "@angular/core";
import { SpinnerService } from "../services/spinner.service";
import { tap, finalize } from 'rxjs/operators';
import { SnackBarService } from './snackbar.service';
import { config } from 'src/assets/config-constant';

@Injectable()
export class RequestInterceptor implements HttpInterceptor {
    messageKey: string = '';
    message: string = '';
    time: number = config.snackBarTimeOut;
    status: string = 'error';
    isSnackbarVisible: boolean = false;
    jsonDataSet: any;

    constructor(private spinner: SpinnerService,
        private snackBarService: SnackBarService) {
        this.jsonDataSet = require('../../assets/i18n/en.json');
    }

    intercept(request: HttpRequest<unknown>, next: HttpHandler): Observable<HttpEvent<any>> {
        this.spinner.setHttpStatus(true);
        return next.handle(request).pipe(
            finalize(() => this.spinner.setHttpStatus(false)),
            tap((ev: HttpEvent<any>) => {
                if (ev instanceof HttpResponse) {
                    this.messageKey = ev.body?.message;
                    switch (this.messageKey) {
                        case 'NotificationEngine.UserPreference.SaveSuccess':
                            this.message = this.jsonDataSet.NotificationEngine.UserPreference.SaveSuccess;
                            this.status = 'success';
                            this.isSnackbarVisible = true;
                            break;
                        case 'NotificationEngine.UserPreference.SaveFail':
                            this.message = this.jsonDataSet.NotificationEngine.UserPreference.SaveFail;
                            this.status = 'error';
                            this.isSnackbarVisible = true;
                            break;
                        case 'NotificationEngine.Unauthorized':
                            this.message = this.jsonDataSet.NotificationEngine.Unauthorized;
                            this.status = 'error';
                            this.isSnackbarVisible = true;
                            break;
                        case 'NotificationEngine.InternalServerError':
                            this.message = this.jsonDataSet.NotificationEngine.InternalServerError;
                            this.status = 'error';
                            this.isSnackbarVisible = true;
                            break;
                        case 'ServerCallSuccessNoMessage':
                            this.isSnackbarVisible = false;
                            break;
                        default: this.isSnackbarVisible = false;
                            break;
                    }
                    if (this.isSnackbarVisible) {
                        this.snackBarService.openCustomSnackBar(this.message, this.status, this.time, 'top', 'center', 'snack-style');
                    }
                }
            },
                (error: HttpErrorResponse) => {
                    this.time = config.snackBarTimeOut;
                    this.status = 'error';
                    this.isSnackbarVisible = true;
                    this.messageKey = error.name;
                    switch (this.messageKey) {
                        case 'NotificationEngine.Unauthorized':
                            this.message = this.jsonDataSet.NotificationEngine.Unauthorized;
                            break;
                        case 'NotificationEngine.InternalServerError':
                            this.message = this.jsonDataSet.NotificationEngine.InternalServerError;
                            break;
                        default:this.message = this.jsonDataSet.NotificationEngine.InternalServerError;
                        break;
                    }
                  this.snackBarService.openCustomSnackBar(this.message, this.status, this.time, 'top', 'center', 'snack-style');
                  throw error;
                }
            )
        );
    }
}